import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import toast from 'react-hot-toast';

import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import TrainingCard from "../components/TrainingCard";
import TrainingCardNew from "../components/TrainingCardNew";
import { FirebaseContext } from '../services/Firebase/Context'
import { AuthContext } from '../services/Session/Context'

const Training = () => {
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext) || {}
  const [records, setRecords] = useState([])

  useEffect(() => {
    if(!user || !db) return
    const q = query(
      collection(db, "training"),
      where("organisationId", "==", user.organisationId),
      orderBy("name"),
      limit(100))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const records: any = [];
      querySnapshot.forEach((doc) => {
        records.push({id: doc.id, ...doc.data()});
      });
      setRecords(records)
    }, (e) => {
      toast.error(e.message)
    });
    return () => unsubscribe()
  }, [db, user])

  return (
    <MainLayout>
      <div className="flex">
        <div className="flex-1">
          <h1 className="text-4xl font-semibold text-gray-800">Vos formations</h1>
          <h2 className=" text-gray-400">Retrouvez la liste de vos formations</h2>
        </div>
        <UserInfos/>
      </div>
      <div className="flex flex-wrap justify-center items-center">
        <TrainingCardNew />
        {
          records.map((r: any) => <TrainingCard  key={r.id} {...r}/>)
        }
      </div>
    </MainLayout>
  ) 
}

export default Training